<template>
  <v-card elevation="2" class="mb-4">
    <v-card-title :class="`${color} white--text`">
      <v-icon left dark>
        {{ icon }}
      </v-icon>
      {{ title }}
      <v-spacer />
      <v-chip
        v-if="showProgress"
        dark
        small
        :color="completionPercent > 50 ? 'success' : 'warning'"
      >
        {{ completionPercent }}% vyplnené
      </v-chip>
    </v-card-title>

    <v-card-text class="pt-4">
      <!-- Silné stránky -->
      <div class="mb-6">
        <div class="d-flex align-center mb-2">
          <v-icon color="success" class="mr-2">mdi-thumb-up</v-icon>
          <span class="text-h6 success--text">Silné stránky</span>
        </div>
        <v-alert
          v-if="infoKeys && infoKeys.silne && manual[infoKeys.silne]"
          color="green lighten-5"
          colored-border
          border="left"
          dense
          class="mb-3"
        >
          <div class="text-subtitle-2 font-weight-medium green--text text--darken-2 mb-1">
            {{ manual[infoKeys.silne].nazov }}
          </div>
          <div
            v-if="manual[infoKeys.silne].priklady"
            class="caption grey--text text--darken-2"
          >
            <strong>Príklady:</strong> {{ manual[infoKeys.silne].priklady }}
          </div>
        </v-alert>
        <v-textarea
          :value="values.silne"
          :disabled="readonly"
          label="Silné stránky"
          placeholder="Popíšte silné stránky..."
          outlined
          auto-grow
          rows="3"
          @input="$emit('update:silne', $event)"
        />
      </div>

      <!-- Slabé stránky -->
      <div class="mb-6">
        <div class="d-flex align-center mb-2">
          <v-icon color="orange" class="mr-2">mdi-thumb-down</v-icon>
          <span class="text-h6 orange--text">Slabé stránky</span>
        </div>
        <v-alert
          v-if="infoKeys && infoKeys.slabe && manual[infoKeys.slabe]"
          color="orange lighten-5"
          colored-border
          border="left"
          dense
          class="mb-3"
        >
          <div class="text-subtitle-2 font-weight-medium orange--text text--darken-2 mb-1">
            {{ manual[infoKeys.slabe].nazov }}
          </div>
          <div
            v-if="manual[infoKeys.slabe].priklady"
            class="caption grey--text text--darken-2"
          >
            <strong>Príklady:</strong> {{ manual[infoKeys.slabe].priklady }}
          </div>
        </v-alert>
        <v-textarea
          :value="values.slabe"
          :disabled="readonly"
          label="Slabé stránky"
          placeholder="Popíšte slabé stránky..."
          outlined
          auto-grow
          rows="3"
          @input="$emit('update:slabe', $event)"
        />
      </div>

      <!-- Príležitosti -->
      <div class="mb-6">
        <div class="d-flex align-center mb-2">
          <v-icon color="primary" class="mr-2">mdi-lightbulb-on</v-icon>
          <span class="text-h6 primary--text">Príležitosti</span>
        </div>
        <v-alert
          v-if="infoKeys && infoKeys.prilezitosti && manual[infoKeys.prilezitosti]"
          color="blue lighten-5"
          colored-border
          border="left"
          dense
          class="mb-3"
        >
          <div class="text-subtitle-2 font-weight-medium primary--text mb-1">
            {{ manual[infoKeys.prilezitosti].nazov }}
          </div>
          <div
            v-if="manual[infoKeys.prilezitosti].priklady"
            class="caption grey--text text--darken-2"
          >
            <strong>Príklady:</strong> {{ manual[infoKeys.prilezitosti].priklady }}
          </div>
        </v-alert>
        <v-textarea
          :value="values.prilezitosti"
          :disabled="readonly"
          label="Príležitosti"
          placeholder="Popíšte príležitosti..."
          outlined
          auto-grow
          rows="3"
          @input="$emit('update:prilezitosti', $event)"
        />
      </div>

      <!-- Ohrozenia -->
      <div>
        <div class="d-flex align-center mb-2">
          <v-icon color="error" class="mr-2">mdi-alert</v-icon>
          <span class="text-h6 error--text">Ohrozenia</span>
        </div>
        <v-alert
          v-if="infoKeys && infoKeys.ohrozenia && manual[infoKeys.ohrozenia]"
          color="red lighten-5"
          colored-border
          border="left"
          dense
          class="mb-3"
        >
          <div class="text-subtitle-2 font-weight-medium error--text mb-1">
            {{ manual[infoKeys.ohrozenia].nazov }}
          </div>
          <div
            v-if="manual[infoKeys.ohrozenia].priklady"
            class="caption grey--text text--darken-2"
          >
            <strong>Príklady:</strong> {{ manual[infoKeys.ohrozenia].priklady }}
          </div>
        </v-alert>
        <v-textarea
          :value="values.ohrozenia"
          :disabled="readonly"
          label="Ohrozenia"
          placeholder="Popíšte ohrozenia..."
          outlined
          auto-grow
          rows="3"
          @input="$emit('update:ohrozenia', $event)"
        />
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'SwotCard',
  props: {
    title: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      default: 'primary',
    },
    icon: {
      type: String,
      default: 'mdi-grid',
    },
    values: {
      type: Object,
      default: () => ({
        silne: '',
        slabe: '',
        prilezitosti: '',
        ohrozenia: '',
      }),
    },
    infoKeys: {
      type: Object,
      default: null,
    },
    manual: {
      type: Object,
      default: () => ({}),
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    showProgress: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    completionPercent() {
      const fields = [this.values.silne, this.values.slabe, this.values.prilezitosti, this.values.ohrozenia];
      const filled = fields.filter(f => f && f.trim().length > 0).length;
      return Math.round((filled / 4) * 100);
    },
  },
};
</script>

